// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Eu1M","field":"styles_field__VDGnY","fieldCol":"styles_fieldCol__1KkNk","diffCol":"styles_diffCol__2BIr6","diff":"styles_diff__32BeJ"};